import api from "./axiosInterceptor";

export const fetchAsanaWorkspaces = () => api.get(`/apps/asana/workspaces`);

export const fetchAsanaWorkspaceProjects = (workspaceId) =>
  api.get(`/apps/asana/projects/${workspaceId}`);

export const createAsanaTask = ({ workspaceId, projectId, data }) =>
  api.post(`/apps/asana/tasks/${workspaceId}/${projectId}`, data);
